module.exports = __webpack_public_path__ + "img/page2.d0c80c3e.png";